import { relation, field, date, text } from '@nozbe/watermelondb/decorators';
import { ANALYTICS_EVENTS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class AnalyticsEvents extends Model {
    static table = ANALYTICS_EVENTS_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
    }

    @field('is_fired') is_fired;
    @field('count') count;
    @text('name') name;

    @date('signup_timestamp') signup_timestamp;
    @date('updated_at') updated_at;

    @relation('user', 'user_id') user;
};